import { render, staticRenderFns } from "./BrowserProgress.vue?vue&type=template&id=b834bc4a&scoped=true"
import script from "./BrowserProgress.vue?vue&type=script&lang=ts"
export * from "./BrowserProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834bc4a",
  null
  
)

export default component.exports